interface Props {
  children: React.ReactNode;
}

const FieldsetFooterAction: React.FC<Props> = ({ children }: Props) => {
  return <div className="ml-auto flex gap-2">{children}</div>;
};

export default FieldsetFooterAction;
